<template>
  <PopupModalWithoutTransition
    :open="open"
    class="sm:max-w-3xl sm:w-full h-[540px] z-50"
    has-close-button
  >
    <template #header>
      <div class="flex items-stretch mb-4">
        <div class="flex flex-col justify-start text-left">
          <span class="text-display2 italic">{{
            $t("info.data.privacy.title.02")
          }}</span>
        </div>
      </div>
    </template>
    <template #body>
      <div class="flex flex-col mt-8 text-left">
        <legal-text
          :text="clientStore.dataprivacy ?? $t('data.privacy')"
          is-data-privacy
        ></legal-text>
      </div>
    </template>
  </PopupModalWithoutTransition>
</template>

<script setup lang="ts">
import PopupModalWithoutTransition from "../layout/PopupModalWithoutTransition.vue";
import { useClientStore } from "../../../store/v2/client";
import LegalText from "./legalText.vue";

const clientStore = useClientStore();
defineProps({
  open: Boolean,
});
</script>
